// @ts-nocheck
/**
 * One-step onboarding for Admin+ Members when opened with ?tour=true.
 * @param {object} vm - Vue component instance with $t
 */
export function buildMembersAdminPlusTourSteps(vm) {
  const t = (key) => vm.$t(key);
  return [
    {
      target: '[data-v-step="2"]',
      icon: require("@/assets/icons/admin+/academy_members.svg"),
      label: t("message.onboarding_members_label"),
      title: t("message.onboarding_members_title"),
      autoClick: false,
      before() {
        const element = document.querySelector('[data-v-step="2"]');
        if (element) {
          element.click();
        }
      },
      description: t("message.onboarding_members_description"),
      params: {
        placement: "left",
        highlight: true,
      },
    },
  ];
}
